import api from "api";

export const fetchClients = () => api.get("/clients");
